
import { View, useWindowDimensions,FlatList, TouchableOpacity,} from 'react-native-web';
import { CardEvent,} from '../../element/Card';
import Eventlist from '../../List/EventList';




const Event = ({navigation}) => {
    const windows=useWindowDimensions();
    
    return (
       
        <View style={{width:windows.width, height:windows.height, alignContent:'center'}}>
             <FlatList data={Eventlist}
                       keyExtractor={(_, index)=>index.toString()}
                       horizontal={true}
                       scrollEnabled={true}
                       pagingEnabled={true}
                       showsHorizontalScrollIndicator={false}
                       renderItem={({ item }) => (
                                                    <View>       
                                                        <TouchableOpacity style={{width:windows.width, height:windows.height, alignItems:'center'}} onPress={()=>{navigation.navigate('DetailEvent', {item})}}>     
                                                            <CardEvent image={item.image} title={item.title}/>
                                                        </TouchableOpacity>  
                                                    </View>)}/>
        </View>);}

export default Event

